import React, { useState } from 'react'
import { NavLink, useParams } from 'react-router-dom';
import { Card, CardBody, Col, Container, Nav, NavItem, Row, TabContent, TabPane } from 'reactstrap';

import slack from "../../../../../../assets/images/brands/slack.png"
import classnames from "classnames";
import OverviewTab from '../../../../../ProjectOverview/OverviewTab';
import DocumentsTab from '../../../../../ProjectOverview/DocumentsTab';
import ActivitiesTab from '../../../../../ProjectOverview/ActivitiesTab';
import TeamTab from '../../../../../ProjectOverview/TeamTab';
import { CompletedListData } from './CompletedListData';

const CompletedDetailPage = () => {
 const [activeTab, setActiveTab] = useState("1");

  const { id } = useParams();
  const item = CompletedListData.find((p) => p.id === Number(id));
  console.log(item)

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };
  console.log(item?.createDate);
  return (
    <React.Fragment>
      <div className="page-content ">
        <Container fluid>
          <Row>
            <Col lg={12}>
              <Card className="mt-n4 mx-n4">
                <div className="bg-warning-subtle">
                  <CardBody className="pb-0 px-4">
                    <Row className="mb-3">
                      <div className="col-md">
                        <Row className="align-items-center g-3">
                          <div className="col-md-auto">
                            <div className="avatar-md">
                              <div className="avatar-title bg-white rounded-circle">
                                <img src={slack} alt="" className="avatar-xs" />
                              </div>
                            </div>
                          </div>
                          <div className="col-md">
                            <div>
                              <h4 className="fw-bold">{item.disputeType}</h4>
                              <div className="hstack gap-3 flex-wrap">
                                <div>
                                  <i className="ri-building-line align-bottom me-1"></i>{" "}
                                  {item.customerName}
                                </div>
                                <div className="vr"></div>
                                <div>
                                  Initiated Date :{" "}
                                  <span className="fw-medium">
                                    {item?.initiatedDate}
                                  </span>
                                </div>
                                <div className="vr"></div>
                                <div>
                                  Transaction Date :{" "}
                                  <span className="fw-medium">
                                    {item?.transactionDate}
                                  </span>
                                </div>
                                <div className="vr"></div>
                                <div className="badge rounded-pill bg-info fs-12">
                                  New
                                </div>
                                <div className="badge rounded-pill bg-danger fs-12">
                                  High
                                </div>
                              </div>
                            </div>
                          </div>
                        </Row>
                      </div>
                      <div className="col-md-auto">
                        <div className="hstack gap-1 flex-wrap">
                          <button
                            type="button"
                            className="btn py-0 fs-16 favourite-btn active"
                          >
                            <i className="ri-star-fill"></i>
                          </button>
                          <button
                            type="button"
                            className="btn py-0 fs-16 text-body"
                          >
                            <i className="ri-share-line"></i>
                          </button>
                          <button
                            type="button"
                            className="btn py-0 fs-16 text-body"
                          >
                            <i className="ri-flag-line"></i>
                          </button>
                        </div>
                      </div>
                    </Row>

                    <Nav
                      className="nav-tabs-custom border-bottom-0 gap-4"
                      role="tablist"
                    >
                      <NavItem>
                        <NavLink
                          className={classnames(
                            { active: activeTab === "1" },
                            "fw-bold me-1"
                          )}
                          onClick={() => {
                            toggleTab("1");
                          }}
                          href="#"
                        >
                          Overview
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames(
                            { active: activeTab === "2" },
                            "fw-bold"
                          )}
                          onClick={() => {
                            toggleTab("2");
                          }}
                          href="#"
                        >
                          Documents
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames(
                            { active: activeTab === "3" },
                            "fw-bold"
                          )}
                          onClick={() => {
                            toggleTab("3");
                          }}
                          href="#"
                        >
                          Activities
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames(
                            { active: activeTab === "4" },
                            "fw-bold"
                          )}
                          onClick={() => {
                            toggleTab("4");
                          }}
                          href="#"
                        >
                          Team
                        </NavLink>
                      </NavItem>
                    </Nav>
                  </CardBody>
                </div>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col lg={12} style={{ overflow: "visible" }}>
              <TabContent
                activeTab={activeTab}
                className="text-muted"
                style={{ overflow: "visible" }}
              >
                <TabPane tabId="1">
                  <OverviewTab item={item} />
                </TabPane>
                <TabPane tabId="2">
                  <DocumentsTab />
                </TabPane>
                <TabPane tabId="3">
                  <ActivitiesTab />
                </TabPane>
                <TabPane tabId="4">
                  <TeamTab />
                </TabPane>
              </TabContent>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default CompletedDetailPage
